import moment from "moment";
import { date } from "yup";

import fallback from "../assets/images/icons/user.png";

export const is_array = (obj) => {
	return Array.isArray(obj);
};

export const random = (num) => {
	const xnum = num == undefined || num == null ? 5232 : num;
	return Math.round(Math.random * xnum - 1);
};

export const slugRemoval = (slug) => {
	return slug.split("-").join(" ").toUpperCase();
};

export const createSlug = (text) => {
	return text.split(" ").join("-").toLowerCase();
};
export const createUScore = (text) => {
	return text.split(" ").join("_").toLowerCase();
};

export const dateToInt = (date_text) => {
	return parseInt(new Date(date_text).getTime() / 1000);
};

export const IntToDate = (date_text) => {
	return moment(parseInt(date_text) * 1000).format("DD-MM-YYYY");
};

export const IntToDateFormat = (date_text) => {
	return moment(parseInt(date_text) * 1000).format("yyyy-MM-DD");
};

export const IntToDateType2 = (date_text) => {
	return moment(parseInt(date_text) * 1000).format("YYYY-MM-DD");
};

export const IntToDateType3 = (date_text) => {
	var dayName = [
		{
			en : 'Monday',
			id : 'Senin'
		}, {
			en : 'Tuesday',
			id : 'Selasa'
		}, {
			en : 'Wednesday',
			id : 'Rabu'
		}, {
			en : 'Thursday',
			id : 'Kamis'
		}, {
			en : 'Friday',
			id : 'Jumat'
		}, {
			en : 'Saturday',
			id : 'Sabtu'
		},  {
			en : 'Sunday',
			id : 'Minggu'
		}
	]

	let day 	= moment(parseInt(date_text) * 1000).format("dddd");
	let dayIndo = dayName.filter((item) => item.en == day)
	let val 	= ""
	if(dayIndo.length > 0) {
		val 	= dayIndo[0]?.id
	}

	return val
};

export const getMonthYear = (value) => {
	return value == undefined ? [null, null] : value.split("-");
};

export const DateToIndo = (month_val, yearVal) => {
	moment.locale("id");
	const data_month_val = `${yearVal}-${month_val}-01`;

	let listMonth = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
	let bulan = listMonth[parseInt(month_val)-1]

	if(bulan == undefined) {
		bulan = ""
	}

	return `${bulan} ${yearVal}`

	// return moment(data_month_val).format("MMMM YYYY");
};

export const fallbackImage_ = (val) => {
	val.target.src = fallback;
};

export const getValueByKey = (data, key) => {
	let value;
	if (data !== null) {
		value = data.filter((item) => item.key === key)[0]?.value;
		if(value == "") {
			value = "-"
		}
	}
	return value;
};

export const DateToID = (date_text) => {
	moment.locale("id");
	let date = new Date(moment(date_text * 1000).format("DD-MM-YYYY HH:mm:ss"));

	let tahun = date.getFullYear();
	let bulan = date.getMonth();
	let tanggal = date.getDate();
	let hari = date.getDay();

	switch (hari) {
		case 0:
			hari = "Minggu";
			break;
		case 1:
			hari = "Senin";
			break;
		case 2:
			hari = "Selasa";
			break;
		case 3:
			hari = "Rabu";
			break;
		case 4:
			hari = "Kamis";
			break;
		case 5:
			hari = "Jum'at";
			break;
		case 6:
			hari = "Sabtu";
			break;
	}

	switch (bulan) {
		case 0:
			bulan = "Januari";
			break;
		case 1:
			bulan = "Februari";
			break;
		case 2:
			bulan = "Maret";
			break;
		case 3:
			bulan = "April";
			break;
		case 4:
			bulan = "Mei";
			break;
		case 5:
			bulan = "Juni";
			break;
		case 6:
			bulan = "Juli";
			break;
		case 7:
			bulan = "Agustus";
			break;
		case 8:
			bulan = "September";
			break;
		case 9:
			bulan = "Oktober";
			break;
		case 10:
			bulan = "November";
			break;
		case 11:
			bulan = "Desember";
			break;
	}

	return `${hari} , ${tanggal} ${bulan} ${tahun}`;
};

export const roleValidation = (roles) => {
	let dataRole = JSON.parse(localStorage.getItem("userData")).user_group;
	let status = false;

	if (dataRole) {
		dataRole.map((item) => {
			for (let index = 0; index < roles.length; index++) {
				if (item.name == roles[index]) {
					status = true;
				}
			}
		});
	}

	return status;
};

export const getWorkunitReport = (workunitName, role, activeWorkunitName) => {
	let name = workunitName

	if(role == "Kabag Sunproglapnil" || role == "Kasubag Sunproglap" || role == "Staff Sunproglap" || role == "Kasubag Panil" || role == "Staff Panil" || role == "Admin" || role == "Super Admin") {

		if (activeWorkunitName != "") {
			name = activeWorkunitName
		} else {
			name = "Semua Laporan"
		}
	} else {
		name = workunitName
	}
	

	return name
}
